import en from './en';

export default { en: { translation: en } };
